import { render, staticRenderFns } from "./quesInstru21.vue?vue&type=template&id=d616bd5e"
import script from "./quesInstru21.vue?vue&type=script&lang=js"
export * from "./quesInstru21.vue?vue&type=script&lang=js"
import style0 from "./quesInstru21.vue?vue&type=style&index=0&id=d616bd5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports